import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Key, ShieldCheck, Zap } from "lucide-react";
import { CartDistributionAnimation } from "./CartDistributionAnimation";


interface CartCreationPrompProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    redirectAction: () => void;
}

const CartCreationPromp = ({ open, onOpenChange, redirectAction }: CartCreationPrompProps) => {

    return (
    <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-2xl">
            <div className="flex flex-col sm:flex-row sm:gap-6">
                {/* Left / top: info content */}
                <div className="flex-1">
                    <DialogHeader>
                        <DialogTitle>
                            <span className="text-lg">¡Vamos a armar tus carritos!</span>
                        </DialogTitle>
                        <DialogDescription>
                            Te conectaremos con cada súpermercado para enviar tus productos.
                        </DialogDescription>
                        <div className="flex items-center justify-center sm:border-l sm:border-gray-100 sm:pl-4 mt-4 sm:mt-0">
                            <CartDistributionAnimation />
                        </div>
                        <div className="text-left text-sm">
                            <ul className="ml-5 mt-2 font-semibold space-y-4">
                                <li><p className="mb-2">
                                    <span className="inline-flex h-9 w-9 mr-2 shrink-0 items-center justify-center rounded-full border bg-red-100 text-foreground">
                                        <Key className="h-4 w-4" />
                                    </span>Inicia sesión en cada tienda.</p>
                                    <span className="text-muted-foreground  font-normal">Entrarás a las páginas oficiales para enlazar tu cuenta.</span>
                                </li>
                                <li><p className="mb-2">
                                    <span className="inline-flex h-9 w-9 mr-2 shrink-0 items-center justify-center rounded-full border bg-blue-100 text-foreground">
                                        <Zap className="h-4 w-4" />
                                    </span>Se hace solo una vez.
                                    </p>
                                    <span className="text-muted-foreground  font-normal">Guardaremos tu conexión de forma segura para que tu próxima compra sea automática.</span>
                                </li>
                                <li><p className="mb-2">
                                    <span className="inline-flex h-9 w-9 mr-2 shrink-0 items-center justify-center rounded-full border bg-green-100 text-foreground">
                                        <ShieldCheck className="h-4 w-4" />
                                    </span>Tus claves son privadas</p>
                                    <span className="text-muted-foreground font-normal">Tus credenciales se ingresan directo en sitio del supermercado. No las vemos ni guardamos.</span>
                                </li>
                            </ul>
                        </div>
                    </DialogHeader>
                </div>

                {/* Right / bottom: animated distribution diagram */}

            </div>

            <DialogFooter>
                <div className="flex flex-col w-full justify-center gap-4 mt-2">
                    <Button onClick={redirectAction} size={"lg"} className="text-sm">Crea tus carritos</Button>
                    <Button variant={"ghost"} onClick={()=>{onOpenChange(false)}}>Ahora no</Button>
                </div>
            </DialogFooter>
        </DialogContent>
    </Dialog>
);
}

export default CartCreationPromp;
